import { Component, Input } from '@angular/core';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

/**
 * Generic Markdown -> sanitized-HTML viewer, meant to be embedded wherever a message body is shown.
 * DOMPurify.sanitize() is the actual XSS boundary here - Angular's own [innerHTML] sanitizer runs on top of
 * that as defense in depth, so bypassSecurityTrustHtml is deliberately not used.
 */
@Component({
  selector: 'app-markdown-viewer',
  standalone: true,
  template: `<div class="markdown-viewer" [innerHTML]="html"></div>`,
  styleUrl: './markdown-viewer.component.scss'
})
export class MarkdownViewerComponent {
  html = '';

  @Input()
  set value(markdown: string | null | undefined) {
    const rendered = markdown ? marked.parse(markdown, { async: false }) : '';
    this.html = DOMPurify.sanitize(rendered);
  }
}
